import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { ExitToApp, ViewColumn, FilterList, AccountCircle } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import moment from 'moment';
import { withRouter, Link, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import konami from '../../images/konami-logo.svg';
// import Log from '../../utils/debug';
import * as eventSearchActionsImport from '../../redux/actions/event-search';
import * as eventNotificationActionImport from '../../redux/actions/notifications';
import * as userActionsImport from '../../redux/actions/user';
import { setUser, logout } from '../../redux/actions/user';

import { notificationSelectorCount, notificationSelectorRows } from '../../selectors/static-looker-dashboard';
import { COOKIE_OPTIONS } from '../../config';
import { KILLSHOT_ORGANIZATION_COOKIE } from '../../constants/cookies';

const Log = console;

const NEG_TWELVE = -12;
const TWENTY = 20;

const TEN = 10;
const FAB_POSITION = -20;

const PATH_HOME = '/';
const PATH_KILLSHOT = '/killshot';
const PATH_NEW_SEARCH = '/newSearch';
const CURRENT_CONTEXT = 'Navbar -> ';
const NOTIFICATION_ID_LINK = '4';
const BUSINESS_ID_LINK = '1';
const SETTINGS_ID = -1;

const styles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.type === 'dark' ? '#FFFFFF' : '#212121',
  },
  flex: {
    flex: 1,
    marginRight: TEN,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  menuButton: {
    marginLeft: NEG_TWELVE,
    marginRight: TWENTY,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1000,
    bottom: FAB_POSITION,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
  navBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  nested: {
    paddingLeft: '15px',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  userInfoEmail: {
    margin: 0,
  },
  userInfoOrganization: {
    margin: 0,
    fontSize: 10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const NotificationsCounter = styled.span`
  background-color: #f44336;
  padding: 5px;
  border-radius: 10px;
  color: white;
  margin: 0 10px;
  &:first-child {
    font-weight: bold;
  }
`;

const initialUserState = {
  username: '',
  token: null,
  isAuthenticated: false,
  organization_id: null,
  userInfo: {},
  menuLinks: [],
  email: '',
};

function Navbar(props) {
  const location = useLocation();
  const classes = styles();
  const { user, history } = props;
  const [state, setState] = useState({
    navDrawerOpen: false,
  });
  const [, setCookie, removeCookie] = useCookies([KILLSHOT_ORGANIZATION_COOKIE]);

  const loadNotifications = () => {
    const { eventActionsNot } = props;

    Log.info(`${CURRENT_CONTEXT} loadNotifications`, true);
    eventActionsNot.fetchNotifications('');
  };

  const useFetchData = email => {
    useEffect(() => {
      if (email && location === '/') loadNotifications();
    }, [email]);
  };

  useFetchData(user.email);

  const handleLoadFilters = () => {
    const { eventActions } = props;
    eventActions.handleLoadFilters(true);
  };

  const handleSaveFilters = () => {
    const { eventActions } = props;
    eventActions.handleSaveFilters(true);
  };

  const handleLoadColumnPresets = () => {
    const { eventActions } = props;
    eventActions.handleLoadColumnPresets(true);
  };

  const handleSaveColumnPresets = () => {
    const { eventActions } = props;
    eventActions.handleSaveColumnPresets(true);
  };

  const handleSignOut = async () => {
    const { dispatch } = props;
    removeCookie(KILLSHOT_ORGANIZATION_COOKIE);
    await logout();
    history.push('/');
    dispatch(setUser(initialUserState));
  };

  const toggleNavDrawer = open => () => {
    setState({
      navDrawerOpen: open,
    });
  };

  const handleToggleFilters = event => {
    const { eventActions } = props;
    event.preventDefault();
    eventActions.handleToggleFiltersMiddleware();
  };

  const {
    presetFilterLoadButtonVisible,
    presetFilterSaveButtonVisible,
    columnPresetLoadButtonVisible,
    showSaveColumnsButton,
    filtersOpen,
    organizationInfo,
    notificationsCount,
    menuLinks,
  } = props;
  const { navDrawerOpen } = state;

  if (!user.email) return <></>;

  let orgId = null;
  if (Array.isArray(user.organizations)) {
    orgId = user.organizations[0]?.id;
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            aria-label="Open Drawer"
            onClick={toggleNavDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <span className={classes.flex}>
            <img
              alt="REPS & Co"
              src={konami}
              style={{ width: '100px', verticalAlign: 'middle', display: 'inline-block' }}
            />
            {location.pathname === PATH_KILLSHOT && (
              <Typography variant="h6" color="inherit" style={{ display: 'inline-block' }}>
                &nbsp;&nbsp;-&nbsp; Killshot
              </Typography>
            )}
          </span>
          {(location.pathname === PATH_HOME || location.pathname === PATH_NEW_SEARCH) && (
            <React.Fragment>
              {filtersOpen && (
                <Button color="inherit" size="small" onClick={handleToggleFilters} className={classes.menuButton}>
                  <VisibilityIcon className={classes.leftIcon} />
                  Show filters
                </Button>
              )}
              {!filtersOpen && (
                <Button color="inherit" size="small" onClick={handleToggleFilters} className={classes.menuButton}>
                  <VisibilityOffIcon className={classes.leftIcon} />
                  Hide Filters
                </Button>
              )}
              {columnPresetLoadButtonVisible && (
                <Button color="inherit" size="small" onClick={handleLoadColumnPresets} className={classes.menuButton}>
                  <ViewColumn className={classes.leftIcon} />
                  Columns
                </Button>
              )}
              {showSaveColumnsButton && (
                <Button color="inherit" size="small" onClick={handleSaveColumnPresets} className={classes.menuButton}>
                  <ViewColumn className={classes.leftIcon} />
                  Save Columns
                </Button>
              )}
              {presetFilterLoadButtonVisible && (
                <Button color="inherit" size="small" onClick={handleLoadFilters} className={classes.menuButton}>
                  <FilterList className={classes.leftIcon} />
                  Filters
                </Button>
              )}
              {presetFilterSaveButtonVisible && (
                <Button color="inherit" size="small" onClick={handleSaveFilters} className={classes.menuButton}>
                  <FilterList className={classes.leftIcon} />
                  Save Filters
                </Button>
              )}
            </React.Fragment>
          )}
          {!!user?.organizations?.length && user?.organizations?.length > 1 && (
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">Organization</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={user.organization?.id || orgId}
                onChange={e => {
                  const o = user.organizations.find(uo => uo.id === e.target.value);
                  props.userActions.setOrganization(o);
                  setCookie(KILLSHOT_ORGANIZATION_COOKIE, o.id, COOKIE_OPTIONS);
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                }}
                label="Organization"
                style={{ color: 'white' }}
              >
                {user.organizations.map(org => (
                  <MenuItem key={org.id} value={org.id}>
                    {org.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <Button
            color="inherit"
            size="small"
            className={classes.menuButton}
            disableRipple
            disableFocusRipple
            disableTouchRipple
            style={{ backgroundColor: 'transparent' }}
            title={user.email}
          >
            <AccountCircle className={classes.leftIcon} />
            <div className={classes.userInfo}>
              <p className={classes.userInfoEmail}>{user.email.split('@')[0]}</p>
              <p className={classes.userInfoOrganization}>{organizationInfo && organizationInfo.name}</p>
            </div>
          </Button>
          <IconButton title="Sign Out" className={classes.menuButton} color="inherit" onClick={handleSignOut}>
            <ExitToApp />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer open={navDrawerOpen} onClose={toggleNavDrawer(false)}>
        <div tabIndex={0} role="button" onClick={toggleNavDrawer(false)} onKeyDown={toggleNavDrawer(false)}>
          <div className={classes.list}>
            <List component="nav">
              {menuLinks.map(link => {
                if (link.child.length) {
                  return [
                    <ListItem key={`link_${link.id}`}>
                      <ListItemText primary="Killshot" />
                    </ListItem>,
                    <List component="div" disablePadding key={`list_${link.id}`}>
                      {link.child.map(child => (
                        <ListItem
                          key={`link_${child.id}`}
                          button
                          component={Link}
                          to={child.url.replace(/(%s)/g, moment().unix())}
                          target={child.new_tab ? '_blank' : '_self'}
                          rel={child.new_tab ? 'noopener noreferrer' : undefined}
                        >
                          <ListItemText primary={child.name} classes={{ primary: classes.nested }} />
                        </ListItem>
                      ))}
                    </List>,
                  ];
                }
                if (NOTIFICATION_ID_LINK === link.id) {
                  return (
                    <ListItem key={`link_${link.id}`} component={Link} to={link.url} button>
                      <ListItemText primary={link.name} />
                      {notificationsCount > 0 && (
                        <NotificationsCounter>
                          <Typography color="inherit">{notificationsCount}</Typography>
                        </NotificationsCounter>
                      )}
                    </ListItem>
                  );
                }
                if (BUSINESS_ID_LINK === link.id) {
                  return (
                    <ListItem key={`link_${link.id}`} component="a" href={link.url} target="_blank" button>
                      <ListItemText primary={link.name} />
                    </ListItem>
                  );
                }

                if (SETTINGS_ID === link.id) {
                  return (
                    <ListItem key={`link_${link.id}`} component="a" href={link.url} button>
                      <ListItemText primary={link.name} />
                    </ListItem>
                  );
                }
                return (
                  <ListItem key={`link_${link.id}`} button>
                    <a className={classes.link} href={process.env.KONAMI_URL + link.url}>
                      <ListItemText primary={link.name} classes={{ primary: classes.nested }} />
                    </a>
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

Navbar.propTypes = {
  eventActions: PropTypes.object.isRequired,
  eventActionsNot: PropTypes.object.isRequired,
  presetFilterLoadButtonVisible: PropTypes.bool.isRequired,
  presetFilterSaveButtonVisible: PropTypes.bool.isRequired,
  columnPresetLoadButtonVisible: PropTypes.bool.isRequired,
  showSaveColumnsButton: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      event_id: PropTypes.node,
    }).isRequired,
  }).isRequired,
  filtersOpen: PropTypes.bool.isRequired,
  notificationsCount: PropTypes.number,
  organizationInfo: PropTypes.object.isRequired,
  menuLinks: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userActions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

Navbar.defaultProps = {
  notificationsCount: 0,
};

function mapStateToProps(state) {
  return {
    presetFilterLoadButtonVisible: state.eventSearch.presetFilterLoadButtonVisible,
    presetFilterSaveButtonVisible: state.eventSearch.presetFilterSaveButtonVisible,
    columnPresetLoadButtonVisible: state.eventSearch.columnPresetLoadButtonVisible,
    columnPresetSaveButtonVisible: state.eventSearch.columnPresetSaveButtonVisible,
    showSaveColumnsButton: state.eventSearch.showSaveColumnsButton,
    filtersOpen: state.eventSearch.filtersOpen,
    notificationsCount: notificationSelectorCount(state),
    notifications: notificationSelectorRows(state),
    organizationInfo: state.user.organizationInfo,
    menuLinks: state.user.menuLinks,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    eventActions: bindActionCreators(eventSearchActionsImport, dispatch),
    eventActionsNot: bindActionCreators(eventNotificationActionImport, dispatch),
    userActions: bindActionCreators(userActionsImport, dispatch),
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
